import { useRouter } from 'next/router';

interface ExpectedQueryParams {
    practiceUuid: string;
    prescriptionUuid: string;
    taskUuid: string;
    cycle?: 'inbox' | 'prescriptions';
    dateRangeStart?: string;
    dateRangeEnd?: string;
    corpGroupId?: string;
    practiceId?: string;
    startMonth?: string;
    endMonth?: string;
    callId?: string;
    reassign?: 'true';

    // For Reach call performance dashboard
    startDay?: string; // YYYY-MM-DD
    endDay?: string; // YYYY-MM-DD

    // For Reach consolidated revenue details page
    dateMMMDYYYY?: string; // e.g. "Sep 1, 2024"

    ePrescriptionDraftId?: string;

    // For Rx prescription details page
    defaultView?: 'original';
    tab?: string;

    // For the inbound call settings checklist
    section?: string;

    // For the Reach analytics page
    attributionDirection?: string;

    // For the Reach inbox page - the selected thread and the active quick-filter view
    thread?: string;
    view?: string;

    // For the Reach practice PIMS Mappings page - the definition tab open
    definition?: string;
}

// Helper hook to grab expected query params with some additional type safety
export function useQueryParams(): ExpectedQueryParams {
    const router = useRouter();
    const {
        practiceUuid,
        prescriptionUuid,
        taskUuid,
        cycle,
        dateRangeStart,
        dateRangeEnd,
        corpGroupId,
        practiceId,
        startMonth,
        endMonth,
        callId,
        startDay,
        endDay,
        dateMMMDYYYY,
        reassign,
        ePrescriptionDraftId,
        defaultView,
        tab,
        section,
        attributionDirection,
        thread,
        view,
        definition,
    } = router.query;

    const expectedQueryParams: ExpectedQueryParams = {
        practiceUuid: practiceUuid?.toString() ?? '',
        prescriptionUuid: prescriptionUuid?.toString() ?? '',
        taskUuid: taskUuid?.toString() ?? '',
        cycle:
            cycle?.toString() === 'inbox'
                ? 'inbox'
                : cycle?.toString() === 'prescriptions'
                  ? 'prescriptions'
                  : undefined,
        dateRangeStart: dateRangeStart ? decodeURIComponent(dateRangeStart.toString()) : '',
        dateRangeEnd: dateRangeEnd ? decodeURIComponent(dateRangeEnd.toString()) : '',
        corpGroupId: corpGroupId?.toString() ?? '',
        practiceId: practiceId?.toString() ?? '',
        startMonth: startMonth?.toString() ?? '',
        endMonth: endMonth?.toString() ?? '',
        callId: callId?.toString() ?? '',
        startDay: startDay?.toString() ?? '',
        endDay: endDay?.toString() ?? '',
        dateMMMDYYYY: dateMMMDYYYY?.toString() ?? '',
        reassign: reassign?.toString() === 'true' ? 'true' : undefined,
        ePrescriptionDraftId: ePrescriptionDraftId?.toString() ?? '',
        defaultView: defaultView?.toString() === 'original' ? 'original' : undefined,
        tab: tab?.toString() ?? '',
        section: section?.toString() ?? '',
        attributionDirection: attributionDirection?.toString() ?? '',
        thread: thread?.toString() ?? '',
        view: view?.toString() ?? '',
        definition: definition?.toString() ?? '',
    };

    return expectedQueryParams;
}
